import API from './api';
import { exportResults } from '../utils/index';
import { HTTP } from '../config/http-common';

export default class UserFolder extends API {
    createMultiUser = async (body) => exportResults(await HTTP.post(`${this.ROUTE}/create_multi_item`, body));
}
